import { useListContext, useNotify, useRefresh, useUnselectAll, useUpdateMany } from "ra-core";
import { BulkDeleteButton, Button } from "react-admin"
import BlockIcon from '@mui/icons-material/Block';
// /import SendMailButton from "../SendMailButton";


const UserListActionButtons = (props: any) =>
    <>
        <AdminBlockButton {...props} />
        <BulkDeleteButton {...props} />
        {/* <SendMailButton {...props} /> */}
    </>


const AdminBlockButton = () => {
    const { selectedIds } = useListContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll('user');
    const [updateMany, { isLoading }] = useUpdateMany(
        'user',
        {
            ids: selectedIds,
            data: { adminBlocked: true },
        }, {
        onSuccess: () => {
            refresh();
            notify('user updated');
            unselectAll();
        },
        onError: error => notify('Error: users not updated', { type: 'warning' }),
    }

    );

    return (
        <Button
            label="Block"
            disabled={isLoading}
            onClick={() => updateMany()}
        >
            <BlockIcon />
        </Button>
    );
}


export default UserListActionButtons;